import { render, staticRenderFns } from "./BudgetReview.vue?vue&type=template&id=1af24ac4&"
import script from "./BudgetReview.vue?vue&type=script&lang=js&"
export * from "./BudgetReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports